import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="container-optia py-16 max-w-lg mx-auto animate-fade-in">
      <Card className="card-soft">
        <CardContent className="p-10 text-center">
          <div className="h-14 w-14 rounded-full bg-slate-200 grid place-items-center mx-auto"><X className="w-7 h-7 text-slate-700" /></div>
          <h1 className="font-display text-2xl font-semibold text-navy-900 mt-5">Pagamento cancelado</h1>
          <p className="text-slate-600 mt-2">Sem estresse — sua consulta ficará como pendente até o pagamento.</p>
          <div className="flex gap-2 justify-center mt-6">
            <Button variant="outline" onClick={()=>nav("/dashboard")}>Ver painel</Button>
            <Button className="bg-teal-500 hover:bg-teal-600" onClick={()=>nav("/profissionais")}>Escolher outro profissional</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
